module.exports = __webpack_public_path__ + "static/media/favicon.383ee514.ico";